export type TSetDataFunction<T> = (oldData: T) => T;

export type TSetData<T> = T | TSetDataFunction<T>;

export const setData = <T>(data: TSetData<T>, oldData: T): T => {
  if (typeof data === 'function') {
    return (data as TSetDataFunction<T>)(oldData);
  } else return data;
};
